import type { z } from 'zod';

import { assessmentSchema } from '@/_containers/assessment/shared';

export const practiceExamSchema = assessmentSchema.omit({
  questions: true,
  last_attempt: true,
  allowGoBack: true,
  showFeedback: true,
  showCorrectAnswer: true,
  forceSubmitAnswerBeforeQuestionChange: true,
});

export type PracticeExamSchema = z.infer<typeof practiceExamSchema>;

export type PurchasedPracticeExamSchema = PracticeExamSchema;
